export default function ErrorMessage({
	className,
	children,
	...props
}: React.ComponentPropsWithoutRef<"p">) {
	return (
		<p
			className="bg-red-500 text-center text-sm text-white flex items-center justify-center p-1 rounded-md"
			role="alert"
			{...props}
		>
			{children}
		</p>
	);
}
